// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"23056700","453":"a0d6a7da"}[chunkId] + ".chunk.js";
};